import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import * as dayjs from 'dayjs';
import { UserAccountRegDto } from 'src/app/core/dtos/dto';
import { RegStatusEnum } from 'src/app/core/dtos/enum';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';
import { DateTimeHelper } from 'src/app/core/services/helpers/date-time.helper';

@Component({
  selector: 'app-list-client-registrations',
  templateUrl: './list-client-registrations.component.html',
  styleUrls: ['./list-client-registrations.component.scss']
})
export class ListClientRegistrationsComponent implements OnInit {

  childAccountRegs: UserAccountRegDto[] = [];
  filteredChildAccountRegs: UserAccountRegDto[] = [];
  regNumber: string;
  partialName: string;
  startFilterDate: Date;
  endFilterDate: Date;
  selectedRegStatus: string;
  yearFromTodayDate = dayjs().add(1, 'year');
  minDate = dayjs('2014-01-01');

  regStatusList = ["All", "Active", "Pending Approval", "Cancelled or Refunded", "Test Taken", "No Show", "Refused Entry", "Scored", "Score Invalidated"];
  localTimeZone: string;

  constructor(
    private accountService: AccountService,
    private toastService: HotToastService,
    private dateTimeHelper: DateTimeHelper
  ) { }

  ngOnInit(): void {
    this.getChildAccountRegs();
    this.localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  getChildAccountRegs() {
    this.accountService.getChildAccountRegs().subscribe(
      result => {
        this.childAccountRegs = result.content;
        for (const childReg of this.childAccountRegs) {
          childReg.regStatusName = this.getRegStatusName(childReg);
          if (childReg.isWebDelivery) {
            childReg.testDateTime = this.dateTimeHelper.convertUTCDateToLocalDate(new Date(childReg.testDateTimeUtc));
          }
        }
        this.getFilteredRegistrations();
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }

  getFilteredRegistrations() {
    let startDate: Date;
    let endDate: Date;
    this.filteredChildAccountRegs = [];
    let partialName = null;
    if (this.partialName != null) {
      partialName = this.partialName.toLowerCase();
    }
    if (this.startFilterDate) {
      startDate = new Date(this.startFilterDate);
      startDate.setHours(0, 0, 0, 0);
    }
    if (this.endFilterDate) {
      endDate = new Date(this.endFilterDate);
      endDate.setHours(23, 59, 59, 999);
    }
    for (const reg of this.childAccountRegs) {
      let add = true;
      const testDateTime = new Date(reg.testDateTime);
      if (this.regNumber && !reg.regId.toString().includes(this.regNumber)) {
        add = false;
      }
      if (partialName && !reg.testTakerFullName.toLowerCase().includes(partialName)) {
        add = false;
      }
      if (this.startFilterDate && testDateTime < startDate) {
        add = false;
      }
      if (add === true && this.endFilterDate && testDateTime > endDate) {
        add = false;
      }
      if (add === true && this.selectedRegStatus && this.selectedRegStatus !== reg.regStatusName && this.selectedRegStatus !== "All") {
        add = false;
      }
      if (reg.regStatusEnum === RegStatusEnum.RegistrationNotAvailable) {
        add = false;
      }
      if (add) {
        this.filteredChildAccountRegs.push(reg);
      }
    }
  }


  getRegStatusName(reg) {
    switch (reg.regStatusEnum) {
      case RegStatusEnum.RegistrationActive:
        return "Active";
      case RegStatusEnum.RegistrationCancelled || RegStatusEnum.RegistrationRefunded:
        return "Cancelled or Refunded";
      case RegStatusEnum.TestTaken:
        return "Test Taken";
      case RegStatusEnum.NoShow || RegStatusEnum.NoShowExpiredID || RegStatusEnum.NoShowMedical
        || RegStatusEnum.NoShowNoID || RegStatusEnum.NoShowWrongID:
        return "No Show";
      case RegStatusEnum.RefusedEntry:
        return "Refused Entry";
      case RegStatusEnum.RegistrationManualApprovalRequired:
        return "Pending Approval";
      case RegStatusEnum.ScorePublished:
        return "Scored";
      case RegStatusEnum.ScoreIncompleteOrMissing || RegStatusEnum.ScoreInvalidated || RegStatusEnum.ScoreUnderReview:
        return "Score Invalidated";
      default:
        return "";
    }
  }
}
